import { NANI_CLUB_OIDC_AUTH_PATH } from "./constants";
import { isNaniDomain, setToken } from "./helpers";

// redirect_uri 由 nani club 後台按 client_id 註冊，前端僅需帶 client_id
export const isNaniClubOidcEnabled = () =>
  isNaniDomain &&
  !!import.meta.env.VITE_NANI_CLUB_API_URL &&
  !!import.meta.env.VITE_NANI_CLUB_OIDC_CLIENT_ID;

export const getNaniClubOidcAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: import.meta.env.VITE_NANI_CLUB_OIDC_CLIENT_ID,
  });

  return `${
    import.meta.env.VITE_NANI_CLUB_API_URL
  }${NANI_CLUB_OIDC_AUTH_PATH}?${params}`;
};

export const consumeNaniClubTokenFromUrl = (): string | null => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");

  if (!token) return null;

  setToken(token);

  // nani club OIDC 回程會把 jwt 掛在 ?token=，收進 cookie 後即從網址移除，
  // 避免 jwt 留在網址。
  url.searchParams.delete("token");
  window.history.replaceState(window.history.state, "", url);

  return token;
};
